export default "__VITE_ASSET__D0pkU9hz__"